import { combineReducers } from 'redux'
import { reducer as formReducer } from 'redux-form'
import reducers from 'LiveBoard/modules'

export default combineReducers({
  ...reducers,
  form: formReducer
})
